import axios from "axios"

export default {
    /* 在actions内请求数据后，将数据通过 mutations 更新到state */
    /* 在组件的 methods 方法内调用 this.$store.dispatch('getData') 或者 this.$store.commit('setData',data) */
    init(context, payload){
        axios.get('home/main/get',{
            params: {
                app_id: payload.app_id || localStorage.getItem('app_id'),
                said: payload.said || localStorage.getItem('said')
            }
        }).then(res=>{
            this.commit('initData', res.data)
        })
    }
}


// WEBPACK FOOTER //
// ./src/store/actions.js